import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import { loadMenu } from '@/libs/router-util'
import { getToken, getTokenRegTime, canGoTo } from '@/libs/util'
import config from '@/config'
import { checkCas, tokenCheck } from '@/api/user'

const { homeName } = config
Vue.use(Router)
const router = new Router({
  routes: [...loadMenu(), ...routes],
  mode: 'history'
})
const LOGIN_PAGE_NAME = config.LOGIN_PAGE_NAME
const LOGIN_PAGE_PATH = config.LOGIN_PAGE_PATH

const turnTo = (to, menus, next) => {
  if (canGoTo(to.name, menus)) next()
  else next({ replace: true, name: 'home' }) // 无访问菜单，重定向到401页面
}

router.beforeEach((to, from, next) => {
  const key = to.query.key
  const uid = to.query.uid
  const ticket = to.query.ticket
  if (key) {
    store.commit('setLoginWay', true)
    store.commit('setToken', key)
    store.commit('setRegTokenTime', key)
    store.commit('setBaseHeaders', key)
  }
  if (uid) {
    store.commit('setUserId', uid)
  }
  iView.LoadingBar.start()
  const token = getToken()
  // 根据index里面的配置进行 区分是否启用单点登录逻辑
  if (config.ssoEnabled) {
    console.log(to)
    if (!token) {
      console.log('token11111111111')
      let data = {
        ticket: ticket
      }
      checkCas(data).then(res => {
        let data = res.data
        if (!data.logined) {
          window.location.href = data.url
        }
      }).catch(res => {})
    } else {
      console.log('token2222')
      // 如果token存在的话 ，先检查token是否有效
      let data = {
        token: token
      }
      tokenCheck(data).then(res => {
        let data = res.data
        if (!data.logined) {
          console.log(data.url)
          window.location.href = data.url
          store.commit('setToken', '')
          store.commit('setBaseHeaders', '')
          store.commit('setAccess', [])
          store.commit('setMenus', []) // 清空菜单
          store.localSave('userMenus', '') // 清空本地保存的菜单数据
          store.commit('setTenants', [])
          store.commit('setGroups', [])
          store.commit('setDefaultTenant', 0)
          store.commit('setSelTenants', [])
          store.commit('setLoginWay', false)
        } else {
          if (!token && to.name !== LOGIN_PAGE_NAME) {
            // 未登录且要跳转的页面不是登录页
            // next({
            //   path: LOGIN_PAGE_PATH, // 跳转到登录页
            //   query: {redirect: to.fullPath}
            // })
            // window.location.href = 'http://sso.aukeyit.com/cas/login?service=http://localhost:8080/'
          } else if (!token && to.name === LOGIN_PAGE_NAME) {
            // 未登陆且要跳转的页面是登录页
            // next() // 跳转
            // window.location.href = 'http://sso.aukeyit.com/cas/login?service=http://localhost:8080/'
          } else if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            next({
              name: homeName // 跳转到homeName页
            })
          } else {
            // 给用户验证的token值续命
            let tokenRegTime = getTokenRegTime()
            let now = parseInt((new Date()).getTime() / 1000)
            let timeDiff = parseInt(tokenRegTime) + 3 * 60 * 60 - now
            if (timeDiff > 0 && timeDiff < (60 * 60)) {
              // 只要在token过期时间 前的 1小时内 有操作，那么系统会触发刷新token的api
              store.dispatch('extendToken')
            }
            if (store.state.user.hasGetInfo) {
              turnTo(to, router.options.routes, next)
            } else {
              store.dispatch('getUserInfo').then(user => {
                // 拉取用户信息，通过判断用户访问的路由是否在角色菜单数组中
                if (token && to.query.key) {
                  // 已登录且要跳转的页面是home
                  router.push({ name: 'home' })
                } else {
                  // 增加对菜单数判断的延迟逻辑 防止获取不到菜单
                  if (router.options.routes.length < 5) {
                    setTimeout(() => {
                      turnTo(to, router.options.routes, next)
                    }, 1000)
                  } else {
                    turnTo(to, router.options.routes, next)
                  }
                  // turnTo(to, router.options.routes, next)
                }
              }).catch(() => {
                console.log(LOGIN_PAGE_PATH)
                store.dispatch('handleLogOut')
                next({
                  path: LOGIN_PAGE_PATH,
                  query: { redirect: to.fullPath }
                })
              })
            }
          }
        }
      }).catch(res => {})
    }
  } else {
    if (!token && to.name !== LOGIN_PAGE_NAME) {
      // 未登录且要跳转的页面不是登录页
      let isTurn = false
      routes.forEach(_route => {
        if (to.path === _route.path) {
          console.log('跳转到无需鉴权的页面')
          console.log(to.path === _route.path)
          isTurn = true
          turnTo(to, router.options.routes, next)
        }
      })
      if (!isTurn) {
        console.log('未登录且要跳转的页面不是登录页')
        next({
          path: LOGIN_PAGE_PATH, // 跳转到登录页
          query: { redirect: to.fullPath }
        })
      }
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
      console.log('未登陆且要跳转的页面是登录页')
      // 未登陆且要跳转的页面是登录页
      next() // 跳转
    } else if (token && to.name === LOGIN_PAGE_NAME) {
      console.log('已登录且要跳转的页面是登录页')
      // 已登录且要跳转的页面是登录页
      next({
        name: homeName // 跳转到homeName页
      })
    } else {
      // 给用户验证的token值续命
      let tokenRegTime = getTokenRegTime()
      console.log('给用户验证的token值续命', tokenRegTime)
      let now = parseInt((new Date()).getTime() / 1000)
      let timeDiff = parseInt(tokenRegTime) + 3 * 60 * 60 - now
      if (timeDiff > 0 && timeDiff < (60 * 60)) {
        // 只要在token过期时间 前的 1小时内 有操作，那么系统会触发刷新token的api
        store.dispatch('extendToken')
      }
      if (store.state.user.hasGetInfo) {
        console.log('store.state.user.hasGetInfo')
        turnTo(to, router.options.routes, next)
      } else {
        store.dispatch('getUserInfo').then(user => {
          // 拉取用户信息，通过判断用户访问的路由是否在角色菜单数组中
          console.log('拉取用户信息，通过判断用户访问的路由是否在角色菜单数组中')
          if (token && to.query.key) {
            // 已登录且要跳转的页面是home
            console.log('已登录且要跳转的页面是home')
            router.push({ name: 'home' })
          } else {
            console.log(to, '已登录且要跳转的页面是home else -', loadMenu(...routes, ...user.codeMenus))
            turnTo(to, loadMenu(...routes, ...user.codeMenus), next)
            // if (loadMenu().length === 0) {
            //   turnTo(to, router.options.routes, next)
            // } else {
            //   turnTo(to, [...loadMenu(), ...routes], next)
            // }
          }
        }).catch(() => {
          store.dispatch('handleLogOut')
          next({
            path: LOGIN_PAGE_PATH,
            query: { redirect: to.fullPath }
          })
        })
      }
    }
  }
})

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
